"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.solarPanelConfig = void 0;
exports.solarPanelConfig = {
    name: 'solarpane',
    fullname: 'Solar Panel',
    description: 'Transforms light from the sun and stars into energy to power buildings.',
    type: 'energy',
    width: 1,
    height: 1,
    levelMax: 9,
    canBeDisabled: false,
    requiredTechnology: 'stone',
    levels: [
        { level: 0, constructionCosts: {}, time: 60, provides: { energy: 1 }, costs: {}, stores: {} },
        { level: 1, constructionCosts: { energy: 10 }, time: 30, provides: { energy: 1 }, costs: {}, stores: {} },
        { level: 2, constructionCosts: { energy: 20 }, time: 20, provides: { energy: 1 }, costs: {}, stores: {} },
        { level: 3, constructionCosts: { energy: 40 }, time: 10, provides: { energy: 1 }, costs: {}, stores: {} },
        { level: 4, constructionCosts: { energy: 60 }, time: 5, provides: { energy: 1 }, costs: {}, stores: {} },
        { level: 5, constructionCosts: { stone: 1000 }, time: 1, provides: { energy: 1 }, costs: {}, stores: {} },
        { level: 6, constructionCosts: { stone: 2500 }, time: 1, provides: { energy: 2 }, costs: {}, stores: {} },
        { level: 7, constructionCosts: { stone: 3000 }, time: 1, provides: { energy: 5 }, costs: {}, stores: {} },
        { level: 8, constructionCosts: { stone: 4000 }, time: 1, provides: { energy: 10 }, costs: {}, stores: {} },
        { level: 9, constructionCosts: { stone: 5000 }, time: 1, provides: { energy: 20 }, costs: {}, stores: {} },
    ],
};



//////////////////
// WEBPACK FOOTER
// ../engine/dist/config/buildings/solarpane.js
// module id = FxZD
// module chunks = 0